import React from "react";
import { Box, Typography } from "@mui/material";

export const TEMPLATE_WIDTH = 3508;
export const TEMPLATE_HEIGHT = 2480;

export const config = {
  width: TEMPLATE_WIDTH,
  height: TEMPLATE_HEIGHT,
  regions: [
    { id: "v1", x: 0.05, y: 0.2, width: 0.43, height: 0.32 },
    { id: "v2", x: 0.52, y: 0.2, width: 0.43, height: 0.32 },
    { id: "v3", x: 0.05, y: 0.56, width: 0.43, height: 0.32 },
    { id: "v4", x: 0.52, y: 0.56, width: 0.43, height: 0.32 },
  ],
  textFields: [
    {
      id: "marca",
      x: 0.05,
      y: 0.04,
      width: 0.25,
      height: 0.05,
      fontSize: 48,
      fontWeight: "bold",
      color: "#ffffff",
      backgroundColor: "#0f0f0f",
    },
  ],
};

const card = {
  border: "1px solid #d4d4d4",
  borderRadius: "8px",
  background: "#fbfbfb",
  position: "relative",
  overflow: "hidden",
};

function PlantillaPrintedJacketsPro({ marca = "MARCA", className }) {
  return (
    <Box
      className={className}
      sx={{
        width: "100%",
        height: "100%",
        aspectRatio: `${TEMPLATE_WIDTH}/${TEMPLATE_HEIGHT}`,
        bgcolor: "#f7f7f7",
        border: "1px solid #d7d7d7",
        borderRadius: "10px",
        position: "relative",
        overflow: "hidden",
      }}
    >
      <Typography
        sx={{
          position: "absolute",
          left: "5%",
          top: "2.6%",
          fontSize: ".16rem",
          color: "#2a2a2a",
          fontWeight: 700,
        }}
      >
        PRINTED JACKET OPTIONS
      </Typography>

      <Box
        sx={{
          position: "absolute",
          left: "5%",
          top: "6%",
          width: "25%",
          height: "5%",
          bgcolor: "#0f0f0f",
          color: "#fff",
          borderRadius: "4px",
          display: "flex",
          alignItems: "center",
          px: 0.9,
        }}
      >
        <Typography sx={{ fontSize: ".25rem", fontWeight: 700 }}>
          {marca}
        </Typography>
      </Box>

      {[
        { x: "5%", y: "20%", id: "V1" },
        { x: "52%", y: "20%", id: "V2" },
        { x: "5%", y: "56%", id: "V3" },
        { x: "52%", y: "56%", id: "V4" },
      ].map((s) => (
        <Box key={s.id} sx={{ position: "absolute", left: s.x, top: s.y, width: "43%", height: "32%", ...card }}>
          <Box sx={{ position: "absolute", inset: "3%", border: "1px dashed #a4a4a4", borderRadius: "6px" }} />
          <Typography sx={{ position: "absolute", right: 6, top: 5, fontSize: ".14rem", color: "#3a3a3a", fontWeight: 700 }}>
            {s.id}
          </Typography>
        </Box>
      ))}
    </Box>
  );
}

export default PlantillaPrintedJacketsPro;
